import { TABLE_ICON_COLUMN_WIDTH } from '../../consts/table';

export const COLUMN_IDS = {
  ENTERPRISE_USER_NAME: 'enterpriseUserName',
  EMAIL: 'email',
  LAST_LOGIN: 'lastLogin',
  STATUS: 'status',
  LINKED_GIT_ACCOUNTS: 'linkedGitAccounts',
  TEAM_ROLE: 'teamRole',
  TEAM: 'team',
  ENVIRONMENT: 'environment',
  ACTIONS: 'action',
} as const;

export const TOOLTIP_SUFFIX = '.tooltip';

export const PAGE_SIZE = 20;
export const INITIAL_USERS_ROWS_COUNT = 20;

export const SEARCH_DEBOUNCE_DELAY = 400;

export const MEMBER_ROLE = {
  user: 'user',
  owner: 'owner',
} as const;

export const MEMBER_TYPE = {
  user: 'user',
  invite: 'invite',
} as const;

export const MEMBER_STATUS = {
  registered: 'registered',
  pending: 'pending',
} as const;

export const URL_QUERY_REPLACE = 'replace';

export const ALL_USERS_OPTION_VALUE = 'all-users';

export const ORGANIZATION_PERMISSIONS = {
  OWNER: 'owner',
  USER: 'user',
} as const;

// Mapping from UI column IDs to server field names
export const UI_TO_SERVER_FIELDS_MAP = {
  enterpriseUserName: 'enterprise_user_name',
  lastLogin: 'last_login',
  linkedGitAccounts: 'linked_git_accounts',
  teamRole: 'team_role',
  team: 'team_name',
  status: 'type',
};

export const TABLE_COLUMN_SIZES = {
  [COLUMN_IDS.ENTERPRISE_USER_NAME]: { minSize: 180, maxSize: 180 },
  [COLUMN_IDS.EMAIL]: { minSize: 300, maxSize: 300 },
  [COLUMN_IDS.LAST_LOGIN]: { minSize: 155, maxSize: 155 },
  [COLUMN_IDS.STATUS]: { minSize: 155, maxSize: 155 },
  [COLUMN_IDS.LINKED_GIT_ACCOUNTS]: { minSize: 205 },
  [COLUMN_IDS.TEAM_ROLE]: { minSize: 135, maxSize: 135 },
  [COLUMN_IDS.TEAM]: { minSize: 155 },
  [COLUMN_IDS.ACTIONS]: {
    minSize: TABLE_ICON_COLUMN_WIDTH,
    maxSize: TABLE_ICON_COLUMN_WIDTH,
  },
};
